module.exports = __webpack_public_path__ + "img/60days.22d0ea0a.png";